<template>
  <div class="home-welcome__bread-animation" ref="animation">
    <slot></slot>
  </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
  name: 'BreadAnimation',
  
  data() {
    return {
      mouseX: 0,
      mouseY: 0
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
      window.addEventListener('mousemove', this.handleMouseMove)
    })
  },
  
  beforeDestroy() {
    window.removeEventListener('mousemove', this.handleMouseMove)
  },
  
  methods: {
    handleMouseMove(event) {
      this.mouseX = (event.clientX / window.innerWidth - 0.5) * 2
      this.mouseY = (event.clientY / window.innerHeight - 0.5) * 2

      const breadItems = this.$el.querySelectorAll('.bread-item')
      
      breadItems.forEach((item, index) => {
        const depth = 1 + (index * 0.2)
        const moveX = this.mouseX * 5 * depth
        const moveY = this.mouseY * 3 * depth
        
        gsap.to(item, {
          xPercent: moveX,
          yPercent: moveY,
          duration: 0.5,
          ease: 'power1.out'
        })
      })
    },

    initAnimation() {
      const breadItems = this.$el.querySelectorAll('.bread-item')
      
      breadItems.forEach((item, index) => {
        gsap.set(item, {
          opacity: 0,
          y: 30
        })
        
        gsap.to(item, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: index * 0.2,
          ease: 'power2.out'
        })
      })
    }
  }
}
</script> 